<template>
  <div class="flag-category-tag" :style="style">
    <slot> </slot>
  </div>
</template>

<script>
export default {
  props: ['subCategory', 'categoryIA', 'subCategoryIA', 'subTag'],
  computed: {
    style() {
      if (this.subCategoryIA) {
        return 'background-color: #efc33d;';
      }
      if (this.subCategory || this.subTag) {
        return 'background-color: #72bcd4;';
      }
      if (this.categoryIA) {
        return 'background-color: #d3d311;';
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.flag-category-tag {
  display: inline-block;
  margin: 5px 4px;
  border-radius: 30px;
  padding: 2px 9px;
  background-color: $gray;
  color: $white;
  font-size: 0.9rem;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/idx-chips/index.vue